export default __webpack_public_path__ + "static/media/group-6438.531a34ae.svg";